import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils'

type CollateralAvailability = {
  isAvailability: boolean
  reason: string
}

type CollateralLimitsResponse = {
  limitUsed: number
  limitWithdraw: number
  depositAvailability: CollateralAvailability
  withdrawAvailability: CollateralAvailability
}

async function fetchCollateralLimits({ accountId }: { accountId: string }) {
  const { data } = await httpClientBanking<CollateralLimitsResponse>({
    url: `/bff_credit_card_limits/accounts/${accountId}/collateral/limits`
  })
  return data
}

export function useFetchCollateralLimits({
  accountId,
  options
}: {
  accountId: string
  options?: { enabled?: boolean }
}) {
  const {
    data: collateralLimits,
    isLoading: isCollateralLimitsLoading,
    isError: isCollateralLimitsError,
    isSuccess: isCollateralLimitsSuccess
  } = useQueryRequest<CollateralLimitsResponse, unknown, true>(
    ['useFetchCollateralLimits', accountId],
    () => fetchCollateralLimits({ accountId }),
    { enabled: Boolean(accountId) && (options?.enabled ?? true), suspense: true }
  )

  return {
    collateralLimits,
    isCollateralLimitsLoading,
    isCollateralLimitsError,
    isCollateralLimitsSuccess
  }
}
